import styled, { css } from 'styled-components';

export const RadioContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const OrderNumber = styled.div`
  display: grid;
  grid-template-columns: min-content min-content;
  gap: 10px;
  div {
    white-space: nowrap;
    font-weight: 400;
    &:first-of-type {
      font-weight: 600;
    }
  }
`;
export const OrdersContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  margin-bottom: 40px;
`;

export const OrderDetails = styled.div<{
  isChecked: boolean;
  isSelectable: boolean;
  isDesktop: boolean;
}>`
  display: grid;
  row-gap: 10px;
  padding: 10px 0;
  align-items: center;
  color: ${({ theme }) => theme.defaultColors.fontSecondary};
  font-weight: 100;
  label {
    ::before {
      background-color: ${({ isChecked, theme, isSelectable }) =>
        isSelectable
          ? isChecked
            ? theme.brandColors.primary
            : 'transparent'
          : theme.greyColors['grey-10']};
      border-color: ${({ theme, isSelectable }) =>
        isSelectable ? '#000000' : theme.greyColors['grey-5']};
    }
  }
  input {
    &:hover {
      border-color: ${({ theme, isSelectable }) =>
        isSelectable ? '#000000' : theme.greyColors['grey-5']};
    }
  }

  ${({ isDesktop, isSelectable }) =>
    isDesktop
      ? css`
          grid-template-columns: ${isSelectable ? '40px 1fr 1fr 2fr 80px' : '0px 1fr 1fr 2fr 80px'};
          grid-template-areas: 'checkbox item-name checkin-checkout item-details item-price more-details';
        `
      : css`
          grid-template-columns: 1fr 40px;
          grid-template-areas:
            'item-name checkbox'
            'checkin-checkout checkin-checkout'
            'item-price item-price'
            'item-details item-details';
        `}
`;

export const PackageDetails = styled(OrderDetails)`
  grid-template-columns: 40px 1fr 1fr 1fr 80px 30px;
  grid-template-areas: 'checkbox item-name item-name item-name item-price more-details';
`;

export const Border = styled.div`
  border-bottom: 1px solid #d7d9d9;
  margin-top: 10px;
`;

export const ItemDetails = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-area: item-details;
`;

export const MoreDetailsToggle = styled.div`
  color: #c89384;
`;
export const MoreDetails = styled.div<{ isExpanded: boolean }>`
  max-height: ${({ isExpanded }) => (isExpanded ? '1000px' : '20px')};
  overflow: hidden;
  grid-area: item-details;
`;

export const OrderDetailsHeading = styled(OrderDetails)`
  font-weight: 800;
  border-bottom: 2px solid #d7d9d9;
  padding: 0 0 10px 0;
`;

export const CancellationPolicy = styled.div`
  font-size: 16px;
`;

export const CheckboxContainer = styled.div`
  grid-area: checkbox;
  margin-right: 10px;
  input:disabled + label::before {
    background-color: ${({ theme }) => theme.greyColors['grey-40']};
    border-color: ${({ theme }) => theme.greyColors['grey-40']};
  }
`;

export const AlertContainer = styled.div`
  div[class*='UnavailableWrapper'] {
    margin-top: 10px;
  }
`;

export const ItemNameContainer = styled.span`
  grid-area: item-name;
`;

export const CheckinCheckoutContainer = styled.div`
  grid-area: checkin-checkout;
`;

export const ItemPrice = styled.div<{ isDesktop: boolean }>`
  grid-area: item-price;
  font-weight: 600;
  width: 100%;
  display: flex;
  justify-content: ${({ isDesktop }) => (isDesktop ? 'flex-end' : 'flex-start')};
`;

export const OrderSummary = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 20px;
  padding: 10px 0;
`;

export const OrderSummaryItems = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  padding: 0 0 10px 10px;
`;

export const OrderSummaryHeadings = styled(OrderSummaryItems)`
  font-weight: 600;
  border-bottom: 2px solid #d7d9d9;
`;

export const MoreDetailsButton = styled.button`
  all: unset;
  grid-area: more-details;
  justify-self: center;
`;
